import propTypes from 'prop-types';
import React, { useState } from 'react';

import { P } from 'common/styles/oc-styled-components';
import { QuestionCircleOutlined } from 'opencare-crown';
import {
  DIMENSIONS,
  useWindowDimensions,
} from 'providers/WindowDimensionsProvider';

import {
  IconWrapper,
  LabelContainer,
  LabelTooltip,
  MobileDisclaimer,
} from './styled-components';

export const Label = ({ label, information }) => {
  const { layout } = useWindowDimensions();
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <LabelContainer>
      <P layout={layout}>{label}</P>
      {information
      && (
        <>
          <IconWrapper>
            <QuestionCircleOutlined
              aria-hidden
              onMouseEnter={() => setShowTooltip(true)}
              onMouseLeave={() => setShowTooltip(false)}
            />
            <LabelTooltip opacity={showTooltip ? '1' : '0'}>
              {information}
            </LabelTooltip>
          </IconWrapper>
          {layout === DIMENSIONS.MOBILE
          && (
            <MobileDisclaimer>
              <P>{information}</P>
            </MobileDisclaimer>
          )}
        </>
      )}
    </LabelContainer>
  );
};

Label.propTypes = {
  label: propTypes.string,
  information: propTypes.string,
};
